import React from "react";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

const CoreSpinner = ({ text, size = 40 }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  return (
    <div className="justify-center items-center flex flex-col w-full h-full   ">
      {text && (
        <div
          className="font-bold text-center"
          style={{ color: `${colorPrimary}` }}
        >
          {text}
        </div>
      )}
      <CircularProgress size={size} style={{ color: `${colorPrimary}` }} />
    </div>
  );
};

export default CoreSpinner;
